import type {
  ProductCardFragment,
  ProductVariantCardFragment,
} from '@boc/framework/saleor-graphql';

import ProductCard from './card';
import VariantCard from './variant-card';

export function ProductGrid({
  products,
  prefetchCount = 6,
}: {
  products: ProductCardFragment[];
  prefetchCount?: number;
}) {
  return (
    <div className="@container/products w-full">
      <div className="grid grid-cols-2 gap-4 @md/products:gap-6 @3xl/products:grid-cols-3 @5xl/products:grid-cols-4">
        {products?.map((product, index) => (
          <ProductCard key={product.id} product={product} prefetch={index < prefetchCount} />
        ))}
      </div>
    </div>
  );
}

export function VariantGrid({
  artStyle,
  variants,
  prefetchCount = 6,
}: {
  variants: ProductVariantCardFragment[];
  prefetchCount?: number;
  artStyle?: 'art' | 'box';
}) {
  return (
    <div className="@container/products w-full">
      <div className="grid grid-cols-2 gap-4 @md/products:gap-6 @3xl/products:grid-cols-3 @5xl/products:grid-cols-4">
        {variants?.map((variant, index) => (
          <VariantCard
            key={`${variant.id}-${artStyle}`}
            variant={variant}
            artStyle={artStyle}
            prefetch={index < prefetchCount}
          />
        ))}
      </div>
    </div>
  );
}
